import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../Controller/CreateAssetNotificationController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Draggable from 'react-draggable';
function CreateSupplierContact({ modalInstance, currentAssetNotifications, onClose, onSuccess, NotificationTypeList, AssetID }) {

    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }

    const [formData, setFormData] = useState({ AssetID: AssetID, vc_Email: '', snt_CheckFrequency: '', dt_LastFrequencyCheck: '' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (currentAssetNotifications) {
            const formattedDate = new Date(currentAssetNotifications.dt_LastFrequencyCheck).toISOString().split('T')[0];
            setFormData({
                AssetID: AssetID, vc_Email: currentAssetNotifications.vc_Email, snt_CheckFrequency: currentAssetNotifications.snt_CheckFrequency,
                dt_LastFrequencyCheck: formattedDate
            });
        } else {
            setFormData({
                AssetID: AssetID, vc_Email: '', snt_CheckFrequency: '', dt_LastFrequencyCheck: ''
            }); // Clear form data when switching to add mode
        }
    }, [currentAssetNotifications]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = (event) => {
        event.preventDefault(); // Prevent default form submission

        if (currentAssetNotifications) {
            formData.PK_AssetNotifications_ID = currentAssetNotifications.PK_AssetNotifications_ID;
        } else {
            formData.PK_AssetNotifications_ID = 0;
        }

        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        handleSubmit(event, formData, setFormData, setErrors, () => {
            onSuccess(); // Call onSuccess to reload data
        }, () => {
            onSuccess(); // Call onSuccess to reload data
        });
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade AssetNotificationModal show d-block" id="AssetNotificationModal" tabIndex="-1" aria-labelledby="AssetNotificationModalLabel" aria-hidden="true" data-backdrop="static">

                    <div className="modal-dialog modal-lg">
                    <Draggable handle=".modal-content" onStart={handleStart}
                cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                            <div className="modal-content">
                                <div className={`modal-header ${accordTheme}`}>
                                    <h5 className="modal-title" id="largeModalLabel">{currentAssetNotifications ? "Edit Notification Schedule" : "Add Notification Schedule"}</h5>
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginTop": "10px", "marginTop": "10px" }}>
                                        <label htmlFor="vc_Email" className="col-sm-3 col-form-label">Email:<span style={{ "color": "red" }}>*</span></label>
                                        <div className="col-sm-4">
                                            <input type="text" className="form-control" name="vc_Email" value={formData.vc_Email} onChange={handleFieldChange} />
                                            {errors.vc_Email && <div style={{ color: 'red' }}>{errors.vc_Email}</div>}
                                        </div>

                                    </div>
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginTop": "10px" }}>

                                        <label htmlFor="vc_Description" className="col-sm-3 col-form-label">Notification Frequency:<span style={{ "color": "red" }}>*</span></label>
                                        <div className="col-sm-4">
                                            <select name="snt_CheckFrequency" className='form-control' value={formData.snt_CheckFrequency} onChange={handleFieldChange}>
                                                <option value="0">Select Notification Frequency</option>
                                                {NotificationTypeList.map((notification) => (
                                                    <option key={notification.ID} value={notification.ID}>
                                                        {notification.Frequency}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.snt_CheckFrequency && <div style={{ color: 'red' }}>{errors.snt_CheckFrequency}</div>}
                                        </div>
                                    </div>
                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginTop": "10px" }}>
                                        <label htmlFor="dt_LastFrequencyCheck" className="col-sm-3 col-form-label">Next Notification Date :<span style={{ "color": "red" }}>*</span></label>
                                        <div className="col-sm-4">
                                            <input type="date" className="form-control" name="dt_LastFrequencyCheck" value={formData.dt_LastFrequencyCheck} onChange={handleFieldChange} />
                                            {errors.dt_LastFrequencyCheck && <div style={{ color: 'red' }}>{errors.dt_LastFrequencyCheck}</div>}
                                        </div>

                                    </div>


                                </div>
                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-primary">
                                        <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} /> {currentAssetNotifications ? " Update" : " Save"}
                                    </button>
                                    <button className="btn btn-danger" type="button" aria-label="Close" onClick={onClose}>
                                        <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                                    </button>
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            </form>
        </div>
    );
}
export default CreateSupplierContact;